module.exports = __webpack_public_path__ + "image/1.8589c6f.png";